<template>
  <v-container v-if="access.includes(roles.reports)">
    <v-card
      class="mx-auto set-height"
    >
      <v-card-title>
        <div class="primary--text">
          Reports
        </div>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
          >
            <v-list>
              <v-list-item-group>
                <v-list-item @click="ShowExport(reports.shift_biometrics_excel)">
                  <v-list-item-content>
                    <v-list-item-subtitle
                      style="font-weight: 700;"
                    >
                      Crew Shift & Biometrics Report
                    </v-list-item-subtitle>
                    <v-list-item-title
                      style="color: #00bcd4;"
                    >
                      ITG Template
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
                <v-list-item @click="ShowExport(reports.shift_biometrics_summary_excel)">
                  <v-list-item-content>
                    <v-list-item-subtitle
                      style="font-weight: 700;"
                    >
                      Crew Shift & Biometrics Report
                    </v-list-item-subtitle>
                    <v-list-item-title
                      style="color: #00bcd4;"
                    >
                      Summary
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
      <br>
    </v-card>
    <!-- Export to Excel dialog -->
    <v-dialog
      v-if="selected_report"
      v-model="show_export"
      width="40%"
      max-width="40%"
    >
      <v-card>
        <v-card-title class="text-left">
          <h2 class="primary--text">
            {{ selected_report.description }}
          </h2>
        </v-card-title>
        <v-card-text>
          <v-col
            v-if="access.includes(roles.stores_switch) || this.access.includes(roles.stores_switch_profit_center)"
            cols="12"
            sm="10"
          >
          <v-select
            ref="role"
            v-model="select_pc"
            :items="profit_centers"
            item-text="description"
            item-value="uid"
            :loading="loading_pc"
            clearable
          >
            <template v-slot:label>
              <div>
                PROFIT CENTER <small>(optional)</small>
              </div>
            </template>
          </v-select>
          </v-col>
          <v-col
            cols="12"
            sm="10"
          >
            <v-text-field
              v-model="personnelidno"
              clearable
              :counter="10"
              :rules="[
                v => v.length ==0 || (v.length == 10 && /^\d*$/.test(v)) || 'Must be 10 characters long, all numeric.'
              ]"
            >
              <template v-slot:label>
                <div>
                  PERSONNELIDNO <small>(optional)</small>
                </div>
              </template>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="10"
          >
            <v-menu
              v-model="date_menu_from"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date_from"
                  label="Date From"
                  readonly
                  required
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="date_from"
                @input="OnDateInput"
              />
            </v-menu>
            <v-menu
              v-model="date_menu_to"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date_to"
                  label="Date To"
                  readonly
                  required
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="date_to"
                @input="OnDateInput"
              />
            </v-menu>
          </v-col>
          <v-btn
            color="green darken-1"
            text
            plain
            style="text-decoration: underline;opacity:1;"
            :class="{ hidden: filename == ''}"
            :href="filename"
            target="_blank"
            download
          >
            Download File
          </v-btn>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="generating"
            color="green darken-1"
            text
            loading
          />
          <v-btn
            color="green darken-1"
            text
            :disabled="generating"
            @click="ExportToExcel()"
          >
            Generate
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="generating"
            @click="show_export = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Export to Excel dialog -->
  </v-container>
</template>

<script>
  import {
    mapState,
  } from 'vuex'
  import {
    ExportToExcel,
  } from '@/graphql/File.gql'
  import moment from 'moment'
  export default {
    data () {
      return {
        select_pc: '',
        selected_report: [],
        show_export: false,
        filename: '',
        personnelidno: '',
        generating: false,
        date_menu_from: false,
        date_menu_to: false,
        date_from: moment().format('YYYY-MM-DD'),
        date_to: moment().format('YYYY-MM-DD'),
      }
    },
    computed: {
      ...mapState(['in_process', 'default_error', 'access', 'roles', 'reports', 'profit_centers', 'profit_centers_hash']),
    },
    mounted () {
      window.scrollTo(0, 0)
    },
    methods: {
      OnDateInput () {
        this.date_menu_from = false
        this.date_menu_to = false
      },
      ShowExport (report) {
        this.select_pc = ''
        this.personnelidno = ''
        this.filename = ''
        this.selected_report = report
        if (!this.access.includes(report.access)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.date_from = moment().format('YYYY-MM-DD')
        this.date_to = this.date_from
        this.show_export = true
      },
      ExportToExcel () {
        this.generating = true
        this.filename = ''
        this.$apollo.mutate({
          mutation: ExportToExcel,
          variables: {
            uid: this.select_pc,
            hash: this.profit_centers_hash,
            personnelidno: this.personnelidno,
            date_from: this.date_from,
            date_to: this.date_to,
            type: this.selected_report.id,
          },
        }).then((res) => {
          if (res.data.ExportToExcel.status === 'Ok') {
            this.filename = res.data.ExportToExcel.data[0].filename
          } else if (res.data.ExportToExcel.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.ExportToExcel.status)
          }
          this.generating = false
        }).catch(error => {
          this.CheckError(error)
          this.generating = false
        })
      },
    },
  }
</script>
